// ✅ الكود الكامل مع تحسين الأداء باستخدام batch processing وعرض بيانات الـ Leads المخصصة مسبقًا

import React, { useRef, useEffect, useState } from 'react';
import { Autocomplete, Box, CircularProgress, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import {
  AssignLeadsMarketerAndAdminAction,
  GetOneClientAction,
  UpdateClientAction,
} from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/esm/Container';
import { Col, Row } from 'react-bootstrap';
import {
  Get_All_Lead_Assigned_Data_Action,
  Get_All_Lead_Selected_To_Assign_Action,
  Insert_Lead_Assigned_Data_Action,
} from '../Redux/Actions/Lead_Assigned_Action';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useTheme } from '@mui/material/styles';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import axios from 'axios';
import SendIcon from '@mui/icons-material/Send';
import { db_url } from '../Api/BaseUrl';
import { io } from 'socket.io-client';

const chunkArray = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) {
    chunked.push(array.slice(i, i + size));
  }
  return chunked;
};

export const SendLeedPage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate(); // ✅ إضافة useNavigate هنا

  const [selectedOption, setSelectedOption] = useState('option1');
  const [selectedStage, setSelectedStage] = useState(null);
  const [userlogin, setuserlogin] = useState('');
  const [salesname, setsalesname] = useState('');
  const [selectedSalesDataArray, setSelectedSalesDataArray] = useState([]);
  const [clearHistory, setClearHistory] = useState(false);
  const [loading, setloading] = useState(true);
  const [sendloading, setsendloading] = useState(false);
  const [transferstorage, settransferstorage] = useState('');
  const [previousAssignedTable, setPreviousAssignedTable] = useState([]);

  const storedLeads = localStorage.getItem('selectedleeds');
  const leadsall = storedLeads ? JSON.parse(storedLeads) : [];
  console.log('leadsall', leadsall);
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    setuserlogin(user);
    settransferstorage(localStorage.getItem('action'));
  }, []);

  useEffect(() => {
    const getData = async () => {
      await dispatch(Get_All_Sales_Action());
      await dispatch(GetOneClientAction(id));
      await dispatch(GetAll_stage_Data());
    };
    getData();
  }, [dispatch, id]);

  const resSalesData = useSelector((state) => state.AllSales.sales?.data || []);
  const resStagesData = useSelector((state) => state.Allstages.stage?.data || []);
  const resleedassindedolddata = useSelector(
    (state) => state.AllLead_Assigned.Lead_Selected_To_Assigned,
  );
  const freshStage = resStagesData.find((stage) => stage.name === 'No Stage');

  const stagechange = (event, newValue) => {
    setSelectedStage(newValue);
    // console.log(newValue.value);
  };

  useEffect(() => {
    // if (leadsall.length) {
    dispatch(Get_All_Lead_Selected_To_Assign_Action(leadsall));
    // }
  }, [dispatch]);

  useEffect(() => {
    if (resleedassindedolddata?.data?.data) {
      setPreviousAssignedTable(resleedassindedolddata?.data?.data);
    }
  }, [resleedassindedolddata]);

  const onsaleschange = (event, selectedOption) => {
    if (selectedOption) {
      setsalesname(selectedOption?._id);
      setSelectedSalesDataArray([selectedOption]);
    } else {
      setsalesname('');
    }
  };

  const senddleedtosalesaction = async (e) => {
    e.preventDefault();
    if (!salesname) return Notify('error', 'Please select sales', 'error');

    setloading(true);
    setsendloading(true);

    try {
      const updateDataTemplate = {
        sales: salesname,
        assign: true,
        lastdateassign: new Date().toLocaleString(),
      };

      if (transferstorage === 'Transfer') {
        if (freshStage?._id) {
          updateDataTemplate.stage = freshStage._id;
        } else {
          Notify('error', 'Failed. Try Again', 'error');
          setTimeout(() => window.location.reload(false), 1500);
          return;
        }
      }

      // ✅ لو المستخدم اختار Change Stage (option2)، أضف الـ stage من الـ Autocomplete
      if (selectedOption === 'option2' && selectedStage?.value) {
        updateDataTemplate.stage = selectedStage.value;
      }
      const leadChunks = chunkArray(leadsall, 10);

      for (const chunk of leadChunks) {
        await Promise.all(
          chunk.map(
            async (leadId) =>
              await dispatch(
                AssignLeadsMarketerAndAdminAction(
                  leadId,
                  userlogin?.data?._id,
                  salesname,
                  clearHistory,
                  updateDataTemplate.stage,
                ),
              ),
          ),
        );
      }

      // if (selectedSalesDataArray[0]?.userlog?.fcmToken) {
      // await axios.post("http://localhost:8000/api/v1/Notification/send-fcm", {
      //   fcmToken: selectedSalesDataArray[0].userlog.fcmToken,
      //   title: "💬 New Assign Lead (FCM)",
      //   body: `New Assign Lead From ${userlogin?.data?.name} To ${selectedSalesDataArray[0]?.name}`,
      // }, {
      //   headers: { "Content-Type": "application/json" }
      // });
      // }

      // for (const chunk of leadChunks) {
      //   await Promise.all(
      //     chunk.map((leadId) =>
      //       dispatch(
      //         Insert_Lead_Assigned_Data_Action({
      //           LeadId: leadId,
      //           date_Assigned: new Date().toISOString().split('T')[0],
      //           Assigned_From: user.data._id,
      //           Assigned_to: salesname,
      //           clearHistory: clearHistory,
      //         })
      //       )
      //     )
      //   );
      // }

      if (transferstorage === 'Transfer') {
        localStorage.removeItem('action');
        settransferstorage('');
      }

      Notify('success', 'Successfully updated', 'success');
      // setTimeout(() => {
      //   const userRole = userlogin?.data?.role;
      //   if (userRole === 'Marketer') {
      //     window.location.href = '#/LeadsForMarketer';
      //   } else {
      //     window.location.href = '#/AllLeads';
      //   }
      // }, 1500);

      // ✅ استخدام navigate للعودة بدلاً من window.location.href
      setTimeout(() => {
        navigate(-1); // ✅ العودة للصفحة السابقة
      }, 1500);
    } catch (err) {
      console.error(err);
      Notify('error', 'Failed to update leads', 'error');
    } finally {
      setloading(false);
      setsendloading(false);
    }
  };

  // 🟨 إعداد ألوان مميزة لكل Lead مشترك
  const colorPalette = [
    '#cc5d5dff',
    '#dff75cff',
    '#64b5f6',
    '#eb920cff',
    '#660c75ff',
    '#09524aff',
    '#06091aff',
    '#f06292',
    '#345a08ff',
    '#010c11ff',
    '#ff8a65',
    '#9575cd',
    '#035f6bff',
    '#180447ff',
    '#7e2504ff',
  ];

  const leadColorMap = {};
  let colorIndex = 0;

  // جمع كل الـ Leads وتعيين لون مميز لكل ID
  previousAssignedTable.forEach((row) => {
    row.leads.forEach((lead) => {
      if (!leadColorMap[lead.leadId]) {
        leadColorMap[lead.leadId] = colorPalette[colorIndex % colorPalette.length];
        colorIndex++;
      }
    });
  });

  return (
    <Container className="startpage">
      <Row>
        <Col sm={2}></Col>
        <Col sm={10}>
          <Link
            to={userlogin?.data?.role === 'Marketer' ? `/dashboard` : `/dashboard`}
            style={{ textDecoration: 'none', color: '#102dff' }}
          >
            <span style={{ fontWeight: 'bold' }}>Dashboard</span>
          </Link>
          <KeyboardDoubleArrowRightIcon />

          <Link
            to={userlogin?.data?.role === 'Marketer' ? `/ALLLeadsForMarketer` : `/AllLeadsForAdmin`}
            style={{ textDecoration: 'none', color: '#102dff' }}
          >
            <span style={{ fontWeight: 'bold' }}>All Leads</span>
          </Link>
          <KeyboardDoubleArrowRightIcon />
          <span style={{ color: '#666' }}>Assign Lead</span>

          <Box>
            <Typography variant="h6">Choose Sales To Send a Lead For Him</Typography>

            {/* <Autocomplete
              options={[...resSalesData].sort((a, b) => {
                const roleOrder = { "Manager": 1, "Team Leader": 2, "Sales": 3 };
                return (roleOrder[a.userlog?.role] || 4) - (roleOrder[b.userlog?.role] || 4);
              })}
              getOptionLabel={(option) => option.name || "Unknown"}
              value={resSalesData.find(s => s._id === salesname) || null}
              onChange={onsaleschange}
              renderInput={(params) => (
                <TextField {...params} label="Choose Sales" fullWidth />
              )}
              style={{ marginTop: 10 }}
            /> */}

            <Autocomplete
              options={[...resSalesData].sort((a, b) => {
                // وضع "No Sales" في البداية
                if (a.name === 'No Sales') return -1;
                if (b.name === 'No Sales') return 1;

                // ثم ترتيب الباقي حسب الدور
                const roleOrder = { Manager: 1, 'Team Leader': 2, Sales: 3 };
                return (roleOrder[a.userlog?.role] || 4) - (roleOrder[b.userlog?.role] || 4);
              })}
              getOptionLabel={(option) => option.name || 'Unknown'}
              value={resSalesData.find((s) => s._id === salesname) || null}
              onChange={onsaleschange}
              renderInput={(params) => <TextField {...params} label="Choose Sales" fullWidth />}
              style={{ marginTop: 10 }}
            />

            <Box display="flex" alignItems="center" mt={2}>
              <input
                type="checkbox"
                checked={clearHistory}
                onChange={(e) => setClearHistory(e.target.checked)}
              />
              <label style={{ marginLeft: '8px', color: '#666' }}>
                Clear previous comments for this sales
              </label>
            </Box>

            {/* ✅ أولاً: الراديو بوتونز */}
            <>
              {/* ✅ أولاً: الراديو بوتونز */}
              <div className="d-flex justify-content-end w-100 flex-wrap gap-3 mb-3">
                <label className={`radio-box ${selectedOption === 'option1' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="customRadio"
                    value="option1"
                    checked={selectedOption === 'option1'}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />
                  <span>Same Stage</span>
                </label>

                <label className={`radio-box ${selectedOption === 'option2' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="customRadio"
                    value="option2"
                    checked={selectedOption === 'option2'}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    style={{ color: mode === 'dark' ? '#666' : '#666' }}
                  />
                  <span>Change Stage</span>
                </label>
              </div>

              {/* ✅ ثانياً: Autocomplete يظهر تحتهم عند اختيار option2 */}

              {selectedOption === 'option2' && (
                <div className="d-flex justify-content-end w-100 mb-3">
                  <div style={{ width: '290px' }}>
                    <Autocomplete
                      options={
                        resStagesData
                          ? resStagesData.map((item) => ({
                              label: item.name, // أو أي اسم العمود اللي بيوصف الستيج
                              value: item._id, // أو أي ID خاص بالستيج
                            }))
                          : []
                      }
                      getOptionLabel={(option) => option.label}
                      value={selectedStage}
                      onChange={stagechange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Stage"
                          variant="outlined"
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                              borderRadius: '12px',
                              padding: '6px 10px',
                              color: mode === 'dark' ? '#90caf9' : '#102dff',
                              boxShadow: mode === 'dark' ? '0 0 4px #1e1e1e' : '0 0 4px #ccc',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#0F7687',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#0F7687',
                            },
                            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#0F7687',
                            },
                            '& .MuiInputLabel-root': {
                              color: mode === 'dark' ? '#90caf9' : '#102dff',
                            },
                            '& .MuiSvgIcon-root': {
                              color: '#102dff',
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              )}

              {/* ✅ ستايل الراديو بوتونز */}
              <style jsx>{`
                .radio-box {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 2px solid #ccc;
                  border-radius: 10px;
                  padding: 12px 24px;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  min-width: 120px;
                  text-align: center;
                  position: relative;
                  font-weight: 500;
                  background-color: #fff;
                }

                .radio-box input {
                  display: none;
                }

                .radio-box.active {
                  border-color: #102dff;
                  background-color: #102dff;
                  // color: white;
                }

                .radio-box:hover {
                  border-color: #102dff;
                }
              `}</style>
            </>

            <hr className="my-4" />
            <div className="d-flex justify-content-center w-100 my-3">
              <div
                onClick={!sendloading ? senddleedtosalesaction : null}
                className="mx-2 button-18"
                style={{ width: '50%', opacity: sendloading ? 0.6 : 1, background: '#102dff' }}
              >
                {sendloading ? (
                  <CircularProgress size={24} style={{ color: 'white' }} />
                ) : (
                  <>
                    <SendIcon className="mx-2" /> Send
                  </>
                )}
              </div>
            </div>

            {previousAssignedTable.length > 0 && (
              <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                  Leads previously assigned (from selected list)
                </Typography>

                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#102dff', color: 'white' }}>
                      <th style={{ padding: '8px', textAlign: 'left' }}>Sales</th>
                      <th style={{ padding: '8px', textAlign: 'left' }}>Leads Count</th>
                      <th style={{ padding: '8px', textAlign: 'left' }}>Leads</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previousAssignedTable.map((row) => (
                      <tr key={row.salesId} style={{ borderBottom: '1px solid #ccc' }}>
                        <td style={{ padding: '8px', fontWeight: 'bold' }}>{row.salesName}</td>
                        <td style={{ padding: '8px' }}>{row.leads.length}</td>
                        <td style={{ padding: '8px' }}>
                          {row.leads.map((lead) => (
                            <span
                              key={lead.leadId}
                              style={{
                                marginRight: '5px',
                                fontSize: '0.9rem',
                                padding: '3px 6px',
                                borderRadius: '4px',
                                backgroundColor: leadColorMap[lead.leadId] || '#e0e0e0',
                                color: 'black',
                                display: 'inline-block',
                              }}
                            >
                              {lead.leadName}
                            </span>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}
          </Box>
        </Col>
      </Row>
    </Container>
  );
};
